import { useState } from "react";

const hotWords = ["宿舍整活", "食堂手抖", "课堂名场面", "期末求生", "表白墙", "社团搞事"];

export default function Hero() {
  const [kw, setKw] = useState("");
  const [toast, setToast] = useState("");

  const submitSearch = () => {
    if (!kw.trim()) {
      setToast("先输入一个关键词，才好帮你找乐子呀～");
      window.setTimeout(() => setToast(""), 2200);
      return;
    }
    setToast(`帮你搜「${kw}」的校园趣事～（演示效果）`);
    window.setTimeout(() => setToast(""), 2400);
  };

  return (
    <section id="top" className="relative overflow-hidden bg-background-50">
      {/* decor blobs */}
      <div aria-hidden="true" className="pointer-events-none absolute -top-24 -left-16 h-72 w-72 rounded-full bg-primary-100/60 blur-2xl"></div>
      <div aria-hidden="true" className="pointer-events-none absolute top-10 right-0 h-80 w-80 rounded-full bg-accent-100/50 blur-2xl"></div>
      <div aria-hidden="true" className="pointer-events-none absolute bottom-0 left-1/3 h-56 w-56 rounded-full bg-secondary-100/60 blur-2xl"></div>

      <div className="relative mx-auto grid max-w-7xl gap-10 px-4 md:px-6 pt-28 md:pt-36 pb-16 md:pb-20 lg:grid-cols-2 lg:items-center">
        <div className="text-center lg:text-left">
          <p className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-4 py-1.5 text-xs md:text-sm text-accent-900">
            <i className="ri-flashlight-fill text-accent-600"></i>
            主打轻松向 · 课后闲聊围观社区
          </p>
          <h1 className="mt-5 text-3xl md:text-5xl font-heading leading-snug text-primary-700">
            课后来吃瓜
            <span className="mx-2 inline-block">🍉</span>
            一起乐一乐
          </h1>
          <p className="mx-auto lg:mx-0 mt-4 max-w-xl text-sm md:text-base leading-relaxed text-foreground-700">
            汇集校园吃瓜段子与趣味日常趣事。下课没事来围观，看看别人班又在整什么活——
            吃瓜能吃到乐子，也能找到聊得来的同好。
          </p>

          <form
            className="mt-6 flex flex-col sm:flex-row gap-2 rounded-2xl bg-background-100 p-2 sm:rounded-full sm:bg-background-100"
            onSubmit={(e) => {
              e.preventDefault();
              submitSearch();
            }}
          >
            <div className="flex flex-1 items-center gap-2 rounded-full bg-background-50 px-4 py-2.5">
              <i className="ri-search-line text-foreground-400 text-base"></i>
              <input
                type="search"
                value={kw}
                onChange={(e) => setKw(e.target.value)}
                placeholder="搜搜今天的乐子…"
                className="w-full bg-transparent text-sm outline-none placeholder:text-foreground-400"
                aria-label="搜索校园趣事"
              />
            </div>
            <button
              type="submit"
              className="whitespace-nowrap rounded-full bg-primary-500 px-6 py-2.5 text-sm text-background-50 hover:bg-primary-600 transition-colors"
            >
              立刻围观
            </button>
          </form>

          <div className="mt-5 flex flex-wrap items-center justify-center lg:justify-start gap-2">
            <span className="text-xs text-foreground-500 whitespace-nowrap">热门围观：</span>
            {hotWords.map((w) => (
              <button
                key={w}
                type="button"
                onClick={() => {
                  setKw(w);
                  submitSearch();
                }}
                className="rounded-full border border-background-300 bg-background-100 px-3 py-1 text-xs text-foreground-700 hover:border-primary-300 hover:text-primary-700 transition-colors whitespace-nowrap"
              >
                {w}
              </button>
            ))}
          </div>

          {toast && (
            <p role="status" className="mt-3 inline-flex items-center gap-2 rounded-full bg-secondary-100 px-4 py-1.5 text-xs text-secondary-900">
              <i className="ri-information-line"></i>
              {toast}
            </p>
          )}
        </div>

        {/* illustration */}
        <div className="relative hidden lg:block">
          <div className="overflow-hidden rounded-[2rem] border border-background-200 bg-background-100 shadow-none">
            <img
              src="https://readdy.ai/api/search-image?query=playful%20flat%20illustration%20of%20happy%20college%20students%20gathered%20around%20sharing%20a%20huge%20watermelon%20and%20gossiping%20together%2C%20laughing%20and%20chatting%2C%20colorful%20coral%20red%20melon%20green%20and%20cream%20background%2C%20cute%20minimal%20vector%20style%2C%20warm%20friendly%20youthful%20mood&width=960&height=720&seq=hero-guagua-2026&orientation=portrait"
              alt="校园吃瓜，大学生围坐吃西瓜聊天的轻松插画"
              className="h-[420px] md:h-[520px] w-full object-cover object-top"
            />
          </div>
          <div className="absolute -bottom-4 -left-6 flex items-center gap-3 rounded-2xl bg-background-50 border border-background-200 px-4 py-3">
            <span className="text-2xl">💬</span>
            <div>
              <p className="text-xs text-foreground-500 whitespace-nowrap">今日在线围观</p>
              <p className="font-heading text-accent-600 text-lg">12,860 位同学</p>
            </div>
          </div>
          <div className="absolute -top-4 -right-4 flex items-center gap-2 rounded-full bg-primary-500 px-4 py-2 text-background-50">
            <i className="ri-fire-fill"></i>
            <span className="text-sm whitespace-nowrap">今日热瓜来袭</span>
          </div>
        </div>
      </div>
    </section>
  );
}